import { defineMessages } from 'react-intl'

const scope = `procurify.modules.reports.features.getReportVendor.UseReportVendorPresenter`

export default defineMessages({
  errorToastTitle: {
    id: `${scope}.errorToastTitle`,
    defaultMessage: 'Error',
  },
  loadErrorFallbackMessage: {
    id: `${scope}.loadErrorFallbackMessage`,
    defaultMessage: 'Unable to load the vendor.',
  },
})
